import { render, staticRenderFns } from "./DeliveryFormDetails.vue?vue&type=template&id=796cc595&scoped=true&"
import script from "./DeliveryFormDetails.vue?vue&type=script&lang=ts&"
export * from "./DeliveryFormDetails.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryFormDetails.vue?vue&type=style&index=0&id=796cc595&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796cc595",
  null
  
)

export default component.exports